import {Dispatch} from "redux";
import {
    GetAllPostReportsAsync,
    GetHelpListAsync,
    GetPostReportAsync, GetPostResultsAsync,
    SendHelpListAsync,
    SendPostReportAsync
} from "../../../services/api-post-practice-service";
import {PostPracticeActionType} from "../../reducers/postPracticeReducer/types";

export const GetPostReport = (city: string, country: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await GetPostReportAsync(city, country);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.POST_REPORT_LOADED,
            payload: response,
        });
    }
}

export const GetAllPostReports = (date?: Date) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await GetAllPostReportsAsync(date);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.ALL_POST_REPORTS_LOADED,
            payload: response,
        });
    }
}

export const SendReport = (report: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await SendPostReportAsync(report);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.FINISH_REQUEST,
            payload: response,
        });
    }
}

export const GetHelpList = (city: string, country: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await GetHelpListAsync(city, country);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.HELP_LIST_LOADED,
            payload: response,
        });
    }
}

export const SendHelpList = (report: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await SendHelpListAsync(report);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.FINISH_REQUEST,
            payload: response,
        });
    }
}

export const GetPostResults = (city: string, country: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PostPracticeActionType.START_REQUEST});
        const data = await GetPostResultsAsync(city, country);
        const {response} = data;
        dispatch({
            type: PostPracticeActionType.POST_RESULTS_LOADED,
            payload: response,
        });
    }
}